import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-9 1.732a8 8 0 0 0 4.001 14.928l-.001 -16a8 8 0 0 0 -4 1.072","key":"svg-0"}]]

/**
 * IconBrightnessFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItYnJpZ2h0bmVzcyIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTcgMy4zNGExMCAxMCAwIDEgMSAtMTUgOC42NmwuMDA1IC0uMzI0YTEwIDEwIDAgMCAxIDE0Ljk5NSAtOC4zMzZtLTkgMS43MzJhOCA4IDAgMCAwIDQuMDAxIDE0LjkyOGwtLjAwMSAtMTZhOCA4IDAgMCAwIC00IDEuMDcyIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/brightness-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrightnessFilled = createReactComponent('filled', 'brightness-filled', 'BrightnessFilled', __iconNode);

export default IconBrightnessFilled;